export default __webpack_public_path__ + "static/5-tips-to-maximise-your-free-global-wi-fi-v1-43ef957653c2e99da2b6a79c863ed158.jpg";